export default {
  heading: 'Dziękujemy za przesłanie zapytania',
  info: 'Zapytanie zostało przesłane!',
  info2: 'Wszystkie szczegóły zostały wysłane na adres mailowy podany w formularzu kontaktowym',
  logout: 'Wyloguj się',
  newOrder: 'Nowe zamówienie',
  download: 'Pobierz ofertę',
};
